import { useMediaQuery } from 'react-responsive'

export const forPhoneOnly = '@media (max-width: 599px)'
export const forLargePhoneUp = '@media (min-width: 410px)'
export const forTabletPortraitUp = '@media (min-width: 600px)'
export const forTabletLandscapeUp = '@media (min-width: 900px)'
export const forDesktopUp = '@media (min-width: 1200px)'
export const forBigDesktopUp = '@media (min-width: 1800px)'
export const forDesktopDown = '@media (max-width: 1199px)'
export const forVerticalPhone = '@media (max-height: 599px)'

export const customMediaQueries = {
  lessThan760: '@media (max-width: 760px)',
}

type UseMediaQuery = ReturnType<typeof useMediaQuery>

export const useIsLargePhoneUp = (): UseMediaQuery => useMediaQuery({ query: '(min-width: 410px)' })
export const useIsTabletPortraitUp = (): UseMediaQuery => useMediaQuery({ query: '(min-width: 600px)' })
export const useIsTabletLandscapeUp = (): UseMediaQuery => useMediaQuery({ query: '(min-width: 900px)' })
export const useIsDesktopUp = (): UseMediaQuery => useMediaQuery({ query: '(min-width: 1200px)' })
export const useIsBigDesktopUp = (): UseMediaQuery => useMediaQuery({ query: '(min-width: 1800px)' })
export const useIsDesktopDown = (): UseMediaQuery => useMediaQuery({ query: '(max-width: 1199px)' })
export const useIsPhoneOnly = (): UseMediaQuery => useMediaQuery({ query: '(max-width: 599px)' })
